export default "__VITE_ASSET__CuY8Nlre__"